import type { AnalyticsProvider, AnalyticsContext } from '../analytics';
import { mixpanelService } from '../mixpanelService';
import { getMixpanelConfig } from '../../../config/mixpanel';

export class MixpanelProvider implements AnalyticsProvider {
  readonly name = 'mixpanel';

  async init(_ctx: AnalyticsContext): Promise<void> {
    const config = await getMixpanelConfig();
    if (!config) return;
    await mixpanelService.init(config);
  }

  track(event: string, props: Record<string, unknown>): void {
    mixpanelService.track(event, props as Record<string, any>);
  }

  identify(userId: string, traits?: Record<string, unknown>): void {
    mixpanelService.identify(userId);
    if (traits && Object.keys(traits).length > 0) {
      mixpanelService.setUserProperties(traits as Record<string, any>);
    }
  }

  page(path: string, props?: Record<string, unknown>): void {
    mixpanelService.track('Page View', { page_path: path, ...props });
  }

  reset(): void {
    mixpanelService.reset();
  }

  async flush(): Promise<void> {
    await mixpanelService.flushEvents();
  }
}
